var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 223,
    viewBox: "0 0 71 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.118 4.60938H4.93487C2.95964 4.60938 1.3584 6.23545 1.3584 8.24132V55.1407C1.3584 57.1466 2.95964 58.7727 4.93487 58.7727H51.118C53.0932 58.7727 54.6945 57.1466 54.6945 55.1407V8.24132C54.6945 6.23545 53.0932 4.60938 51.118 4.60938Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7305 28.4747L27.756 44.7488L70.2712 1.57422",
    stroke: "#FF85A4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.118 86.1758H4.93487C2.95964 86.1758 1.3584 87.8019 1.3584 89.8077V136.707C1.3584 138.713 2.95964 140.339 4.93487 140.339H51.118C53.0932 140.339 54.6945 138.713 54.6945 136.707V89.8077C54.6945 87.8019 53.0932 86.1758 51.118 86.1758Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7305 110.041L27.756 126.315L70.2712 83.1406",
    stroke: "#FF85A4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.118 167.742H4.93487C2.95964 167.742 1.3584 169.368 1.3584 171.374V218.274C1.3584 220.279 2.95964 221.905 4.93487 221.905H51.118C53.0932 221.905 54.6945 220.279 54.6945 218.274V171.374C54.6945 169.368 53.0932 167.742 51.118 167.742Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.4775,
    height: 221.929,
    fill: "white",
    transform: "translate(0.443359 0.914062)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ae9699ae332bdad70a98e1a9e0e68ac1.svg";
export { ForwardRef as ReactComponent };